import {
  DESTINATION_CARD_DESCRIPTION_FALLBACK,
  DESTINATION_CARD_TITLE_FALLBACK,
} from './homepageCarousel.constants';

/** Same cleaner the homepage used inline before the sections were split out. */
export function cleanHomepageText(text) {
  if (!text) return '';
  return text
    .replace(/[^\x20-\x7E\u00A0-\u024F\u2000-\u206F\u2013\u2014\u2018\u2019\u201C\u201D\u2026\u00B0\u20B9\u20AC\u00A3\u00A5]/g, ' ')
    .replace(/\s{2,}/g, ' ')
    .trim();
}

export function mapSectionToLegacyFormat(section) {
  if (!section || !section.destinations) return [];
  return section.destinations.map((destination) => {
    const description = cleanHomepageText(destination.description || destination.subtitle || '');
    const json = {
      hero: {
        image: destination.heroImage || '',
        title: destination.name,
        subtitle: cleanHomepageText(destination.subtitle || ''),
        description,
      },
      place: {
        name: destination.name,
        country: destination.location || (destination.scope === 'domestic' ? 'India' : ''),
      },
    };
    if (destination.galleryImages?.length) {
      json.attractions = { sites: destination.galleryImages.map((image) => ({ image })) };
    }
    return {
      destination: destination.name,
      category: section.title,
      output_json: json,
      cardTitle: destination.name || DESTINATION_CARD_TITLE_FALLBACK,
      cardDescription: description || DESTINATION_CARD_DESCRIPTION_FALLBACK,
      cardImage: destination.heroImage || '',
    };
  });
}

/** Split the homepage-sections payload into the five lists the page already renders. */
export function applyHomepageSections(sections) {
  const sectionMap = {};
  const meta = {};
  (sections || []).forEach((section) => {
    sectionMap[section.sectionId] = section;
    meta[section.sectionId] = { title: section.title, subtitle: section.subtitle };
  });
  return {
    meta,
    trending: mapSectionToLegacyFormat(sectionMap[1] || null),
    international: mapSectionToLegacyFormat(sectionMap[2] || null),
    weekend: mapSectionToLegacyFormat(sectionMap[3] || null),
    visaFree: mapSectionToLegacyFormat(sectionMap[4] || null),
    seasonal: mapSectionToLegacyFormat(sectionMap[5] || null),
  };
}
